import React, { useState } from 'react';
import { Check, Sparkles } from 'lucide-react';
import { customizationOptions } from '../data/mock';

const CustomizationSection = () => {
  const [activeCategory, setActiveCategory] = useState(customizationOptions[0]);

  const finishPreviews = {
    'Mirror Finish SS': 'linear-gradient(135deg, #E8E8E8 0%, #FFFFFF 50%, #E8E8E8 100%)',
    'Hairline SS': 'linear-gradient(90deg, #D0D0D0 0%, #E8E8E8 50%, #D0D0D0 100%)',
    'Textured SS': 'linear-gradient(45deg, #C0C0C0 25%, #D8D8D8 25%, #D8D8D8 50%, #C0C0C0 50%, #C0C0C0 75%, #D8D8D8 75%, #D8D8D8 100%)',
    'Golden Finish': 'linear-gradient(135deg, #B8956B 0%, #D4B896 50%, #B8956B 100%)',
    'Rose Gold': 'linear-gradient(135deg, #C4A484 0%, #E8D4C4 50%, #C4A484 100%)',
    'Bronze': 'linear-gradient(135deg, #9C7A50 0%, #C4A070 50%, #9C7A50 100%)'
  };

  return (
    <section id="customization" className="section-padding bg-[#252A32] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 customization-pattern" />
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#B8956B] font-medium text-sm uppercase tracking-[0.2em] mb-4">
            <Sparkles className="w-4 h-4" />
            Customization Studio
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6 heading-display">
            Design Your <span className="text-[#B8956B] italic">Dream Elevator</span>
          </h2>
          <div className="elegant-divider mx-auto mb-6" />
          <p className="text-gray-400 text-lg">
            Every elevator is a blank canvas. Choose from our extensive range of finishes, 
            materials, and designs to create an elevator that reflects your style.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {customizationOptions.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all tracking-wide text-sm ${
                activeCategory.id === category.id
                  ? 'bg-[#B8956B] text-white'
                  : 'bg-white/5 text-gray-300 hover:bg-white/10 border border-white/10'
              }`}
            >
              {category.category}
            </button>
          ))}
        </div>

        {/* Options Display */}
        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 lg:p-12 border border-white/5">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {activeCategory.options.map((option, index) => (
              <div 
                key={index}
                className="group bg-white/5 rounded-2xl p-6 border border-white/5 hover:border-[#B8956B]/30 transition-all cursor-pointer"
              >
                {/* Preview */}
                <div 
                  className="w-full h-32 rounded-xl mb-4 transition-transform group-hover:scale-[1.02]"
                  style={{ 
                    background: finishPreviews[option] || 'linear-gradient(135deg, #5A6168 0%, #7A8188 100%)'
                  }}
                />
                <div className="flex items-center justify-between">
                  <span className="text-white font-medium">{option}</span>
                  <div className="w-7 h-7 rounded-full bg-[#B8956B]/15 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <Check className="w-4 h-4 text-[#B8956B]" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Text */}
        <div className="text-center mt-12">
          <p className="text-gray-400 text-lg mb-4 italic heading-display">
            "Designed as per your ideas & needs"
          </p>
          <p className="text-[#B8956B] font-medium tracking-wide text-sm">
            SS 304 Grade • Toughened Glass • Premium Finishes Available
          </p>
        </div>

        {/* Special Offer */}
        <div className="mt-16 bg-white/5 rounded-2xl p-8 border border-[#B8956B]/20">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <span className="inline-block bg-[#B8956B] text-white text-xs font-medium px-3 py-1.5 rounded-full mb-3 tracking-wider">
                FIRST TIME IN INDIA
              </span>
              <h3 className="text-2xl font-semibold text-white mb-2 heading-display">Special Home Lift Design</h3>
              <p className="text-gray-400">Gearless MRL Lift - Perfect for residential spaces</p>
            </div>
            <div className="text-center lg:text-right">
              <p className="text-[#B8956B] text-sm tracking-wide">Starting from</p>
              <p className="text-4xl font-semibold text-white heading-display">₹5,00,000/-</p>
              <p className="text-gray-500 text-sm">*Terms apply</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomizationSection;
